document.addEventListener('DOMContentLoaded', () => {
  /* 1. Grab only the .site-nav-item whose inner .text === "Ver Todos" */
  const targetItems = [...document.querySelectorAll('.site-nav.dropdown .site-nav-item')]
    .filter(item => {
      const textNode = item.querySelector('.site-nav-link .text');
      return textNode && textNode.textContent.trim() === 'Ver Todos';
    });

  /* 2. Append a “→” (only once) */
  targetItems.forEach(item => {
    const textNode = item.querySelector('.site-nav-link .text');
    if (textNode && !textNode.dataset.arrowAdded) {    // guard against duplicates
      textNode.insertAdjacentHTML('beforeend', ' &rarr;');
      textNode.dataset.arrowAdded = 'yes';
    }
  });

  /* 3. Hide/show the elements at ≤ 1024 px and on every resize */
  function toggleVisibility () {
    const hide = window.innerWidth <= 1024;
    targetItems.forEach(el => {
      el.style.display = hide ? 'none' : '';
    });
  }

  toggleVisibility();                     // initial check
  window.addEventListener('resize', toggleVisibility);

  function copyToClipboard(element) {
		var oldValue = $(element).html();

		navigator.clipboard.writeText(oldValue);

		$(element).html("COPIADO");
		setTimeout(function () {
			$(element).html(oldValue);
		}, 300);
	}

	$("cupom").click(function () {
		copyToClipboard(this);
	});

  function insertCustomFormCSS() {
    const observer = new MutationObserver((mutationList, observer) => {
        const form = document.querySelector("form-embed");

        if(form) {
          document.querySelector('.contact-itemLeft').insertAdjacentElement("beforeend", form);
          observer.disconnect();

          const shadow = form.shadowRoot
    
          const customCss = new CSSStyleSheet();
          customCss.insertRule(`
              [class*="_formContainer_"] {
                width: 100% !important;
                max-width: 99% !important;
              }
          `)

            shadow.adoptedStyleSheets.push(customCss)
        }
    })
    observer.observe(document.body, {childList: true, subtree: true})

  }

  if(window.location.href.includes('fale-conosco')) {
    insertCustomFormCSS();
  }

  $(document).on('click', '[data-open-spotlight-popup]', function(event) {
    const item = event.target.classList.contains('spotlight-item') ? event.target : event.target.closest('.spotlight-item')
    const openModalClass = item.dataset.openSpotlightPopup;

    document.body.classList.add(openModalClass);
    document.querySelector('.background-overlay').setAttribute('data-close-frete-popup', openModalClass)
  })

  $(document).on('click', '.background-overlay', function(event) {
    const overlay = document.querySelector('.background-overlay');
    document.body.classList.remove(overlay.dataset.closeFretePopup ? overlay.dataset.closeFretePopup : '');
  })
});
